import * as types from '../../mutation-types.js';
import http from '@service/http';
import util from '@common/utils/util';

/**
 * 实体店 STORE
 */
export default {
  state: {

  },
  actions: {
  	//分页获取实体门店信息
	pageDealerStore({commit},data){
		return http.post({
			fn: 'mallsale.dealerHandler.pageDealerStore',
			param: data
		}).then(result => {
			if(result && result.success && result.target && result.target.success){
				return Promise.resolve(result.target.target);
			}else{
				return Promise.reject((result && (result.message || result.target.message)) || '获取信息失败');
			}
		}).catch(error => {
			return Promise.reject(error);
		})
	},

  },
  mutations: {

  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/physicalStores/index.js